import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { fetchAuthSession } from 'aws-amplify/auth';

const proxyPrefix = process.env.REACT_APP_PROXY_PREFIX || '';
const baseApi     = process.env.REACT_APP_API_BASE_URL || '';
const endPoint    = 'v2/v2/drafts';

const url = proxyPrefix + baseApi + endPoint;

export const draftsApi = createApi({
  reducerPath: 'draftsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: url,
    prepareHeaders: async (headers) => {
      const session = await fetchAuthSession();
      const token = session.tokens.idToken.toString();
      if (token) {
        headers.set('Authorization', `${token}`);
        headers.set('Content-Type', 'application/json');
      }
      return headers;
    },
  }),
  tagTypes: ['Drafts'],
  endpoints: () => ({}),
});